function base62ToInteger(s) {
    const BASE62 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let result = 0;
    for (let i = 0; i < s.length; i++) {
        const power = s.length - 1 - i;
        const digit = BASE62.indexOf(s[i]);
        result += digit * Math.pow(62, power);
    }

    return result;
}

function hashToRange(id, range) {
    const largeNum = base62ToInteger(id.toUpperCase());
    return largeNum % range;
}

const calculatePerlinNoiseSeed = () => {
    const currentTime = new Date();
    const timeInHours = currentTime.getHours() + currentTime.getMinutes() / 30;
    return Math.sin(((timeInHours + 17) / 12) * Math.PI) * 150;
};

export const getNoise = (id, {range = 199, min = 149, max = 199} = {}) => {
    const seed = calculatePerlinNoiseSeed();
    const base = hashToRange(id, range);
    let value = Math.round(Math.abs(seed)) + base;
    const original_min = -449;
    const original_max = 250;
    const desired_min = min;
    const normalizedValue = ((value - original_min) / (original_max - original_min)) * (max - desired_min) + desired_min;
    return {value: Math.round(normalizedValue)};
};